var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.windowClass},[_vm._v(" Fishcars ")])}
var staticRenderFns = []

export { render, staticRenderFns }